<template lang="html">
	<div 
		class="form-group" 
		v-if="form">
		<label :for="randomId">{{ label }}</label>
		<div 
			class="input-group" 
			:id="randomId" >
			<input 
				type="text" 
				class="form-control" 
				v-model="time" 
				@input="input" 
				placeholder="hh:mm">
		</div>
	</div>
	<span 
		class="input-time" 
		v-else>
		<input 
			type="text" 
			class="form-control" 
			v-model="time" 
			@input="input" 
			placeholder="hh:mm">
	</span>
</template>

<script>
export default {
	name: 'InputTime',
	props: {
		value: String,
		form: Boolean,
		label: String
	},
	data() {
		return {
			time: '',
			randomId: 'input-' + Math.floor(Math.random() * 10000)
		}
	},
	watch: {
		unit() {
			this.init()
		},
		value() {
			this.init()
		}
	},
	mounted() {
		this.init()
	},
	methods: {
		init() {
			if (this.value)
				this.input({
					target: {
						value: this.value
					}
				})
		},
		input(e) {
			const rawValue = e.target.value.slice(0, 5)
			const value = rawValue.split('')
			if (isNaN(parseInt(value[value.length - 1]))) value.pop()
			if (value.length > 2 && value[2] !== ':') value.splice(2, 0, ':')

			const hour = parseInt(rawValue.slice(0, 2))
			if (hour > 23) value.splice(0, 2, '23')
			const minute = parseInt(rawValue.slice(3, 5))
			if (minute > 59) value.splice(3, 5, '23')
			this.time = value.join('')
			this.$emit('input', this.time)
		}
	}
}
</script>

<style lang="css">
.input-time{
    display: inline-block;
}
</style>
